import { IListItem } from '../ListView'
import { ObjectListViewTitleAdapter } from './ObjectListViewTitleAdapter'

/**
 * This class is typically used in conjunction with {@link ObjectListViewTitleAdapter}.
 * It accepts an object and a list of field names that should be displayed in the list view.
 */
export class ObjectListViewItemAdapter implements IListItem {
	data: any
	id: string
	columns: any[]

	constructor(data: any, fields: string[]) {
		this.data = data
		this.id = data.id
		this.columns = fields.map((field) => this.data[field])
	}
}
